<script>
	import Tesla from '@project/containers/Tesla.svelte'
	import Baseball from '@project/containers/Baseball.svelte'
	import Frog from '@project/containers/Frog.svelte'
	import Future from '@project/containers/Future.svelte'

	import { onMount, tick } from 'svelte'

	const options = [
		{ component: Tesla },
		{ component: Frog },
		{ component: Future },
		{ component: Baseball }
	]

	let selected = {}

	onMount(async () => {
		await tick()
		selected = options[Math.floor(Math.random() * options.length)]
	})
</script>


{#if selected}
	<svelte:component this={selected.component}/>
{/if}